module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "highlight.eff4b317.svg";